var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVolume2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280 585 c-82 -72 -87 -75 -136 -75 -61 0 -64 -4 -64 -100 0 -96 3 -100 63 -100 48 0 54 -3 139 -76 55 -47 94 -74 103 -70 23 8 18 490 -5 493 -8 1 -53 -31 -100 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 582 c0 -6 11 -34 25 -64 34 -73 34 -147 -1 -217 -15 -28 -24 -55 -21 -58 28 -27 77 86 77 176 0 43 -7 71 -27 111 -26 49 -53 76 -53 52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 531 c-4 -6 3 -24 15 -41 17 -22 23 -44 23 -80 0 -36 -6 -58 -23 -80 -28 -38 -18 -60 14 -30 35 33 50 100 35 154 -13 47 -53 95 -64 77z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVolume2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-volume-2.2dc329f7361341342ea2216bf0a411d7.svg";